import React from 'react'
import {
  SubFLex,
  MainHeading,
  SecondaryHeading,
  SecondGreyText,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import { COLORS } from 'theme'

const CurrentlyPursuingDetails = ({ studentData }) => {
  return (
    <>
      <MainHeading>Currently Pursuing</MainHeading>
      <SubFLex column gap="10px">
        {studentData?.previousCollege ? (
          <SecondaryHeading fontWeight="600">
            {studentData?.previousCollege} -{studentData?.previousUniversity}
          </SecondaryHeading>
        ) : null}

        {studentData?.degree ? (
          <SecondGreyText>
            {studentData?.degree} Degree in {studentData?.department}{' '}
            {studentData?.specialisation && `(${studentData?.specialisation})`}
          </SecondGreyText>
        ) : null}
        {studentData?.averageMarks ? (
          <SubFLex gap="25px">
            <SecondGreyText color={COLORS.GREY_T_60}>
              Average Mark
            </SecondGreyText>
            <SecondGreyText>-</SecondGreyText>
            <SecondGreyText>
              {parseFloat(studentData?.averageMarks).toFixed(2)}%
            </SecondGreyText>
          </SubFLex>
        ) : null}
      </SubFLex>
    </>
  )
}

export default CurrentlyPursuingDetails
